<script>import Tag from "../Tag.svelte";
export let props;
$: props = {
  ...props,
  classNames: `${props.classNames ?? ""} bg-white border border-secondary text-secondary`
};
</script>

<Tag {props}>
	<slot />
</Tag>
